/**
 * achtBytes IoT API
 * The achtBytes IoT API handles all portal functionality.
 *
 * The version of the OpenAPI document: v1
 * Contact: info@achtbytes.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AssetMapNodeType = 0 | 1 | 2 | 3;

export const AssetMapNodeType = {
    NUMBER_0: 0 as AssetMapNodeType,
    NUMBER_1: 1 as AssetMapNodeType,
    NUMBER_2: 2 as AssetMapNodeType,
    NUMBER_3: 3 as AssetMapNodeType
};

